import DocButtonLink from "components/Links/DocButtonLink";
import * as React from 'react';
export default {
  DocButtonLink,
  React
};